import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../style.css";
import townBuilding from "../Assets/TownLogo/about-img.webp";
import gardenView from "../Assets/TownLogo/about-top-img.webp";
import "../output.css";
import "swiper/css/navigation";
import port1 from "../Assets/CLUB_INTERIOR/BANQUET.webp";
import port2 from "../Assets/CLUB_INTERIOR/GAMEROOM.webp";
import port3 from "../Assets/CLUB_INTERIOR/GYM.webp";
import port4 from "../Assets/CLUB_INTERIOR/RECEPTION.webp";
import joy1 from "../Assets/fla-6/fla-1.webp";
import joy2 from "../Assets/fla-6/fla-2.webp";
import joy3 from "../Assets/fla-6/fla-3.webp";
import joy4 from "../Assets/fla-6/fla-4.webp";
import joy5 from "../Assets/fla-6/fla-5.webp";
import joy6 from "../Assets/fla-6/fla-6.webp";
import img1 from "../Assets/fla-6/exterio-1.webp";
import img2 from "../Assets/fla-6/exterio-2.webp";
import img3 from "../Assets/fla-6/exterio-3.webp";
import img4 from "../Assets/fla-6/exterio-4.webp";
import img5 from "../Assets/fla-6/exterio-5.webp";
import icon1 from "../Assets/fla-6/icon-1.webp";
import icon2 from "../Assets/fla-6/icon-2.webp";
import icon3 from "../Assets/fla-6/icon-3.webp";
import icon4 from "../Assets/fla-6/icon-4.webp";
import video from "../Assets/Media/Amayra-Trillium-New.mp4";

gsap.registerPlugin(ScrollTrigger);

const HomePage = () => {
  const headingRef = useRef(null);
  const imageScrollRef = useRef(null);
  const [portfolioItems] = useState([
    {
      title: "GreenWaves",
      subtitle: "Eco-Warriors",
      image: port1,
    },
    {
      title: "Mystic Horizons",
      subtitle: "ModeElite",
      image: port2,
    },
    {
      title: "Pixel Fusion",
      subtitle: "Techno",
      image: port3,
    },
    {
      title: "EcoExplorer",
      subtitle: "GreenEarth",
      image: port4,
    },
  ]);
  const [currentSlide, setCurrentSlide] = useState(0);

  // Use fewer images for mobile for faster load
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const images = isMobile
    ? [joy1, joy2, joy3]
    : [joy1, joy2, joy3, joy4, joy5, joy6];

  const boxes = [
    {
      title: "Quality Construction",
      icon: icon1,
      desc: "Every project is built with precision, durability, and attention to detail.",
    },
    {
      title: "On-Time Delivery",
      icon: icon2,
      desc: "We value your time and ensure timely possession without compromising quality.",
    },
    {
      title: "Transparent Dealings",
      icon: icon3,
      desc: "Clear communication and honest pricing with no hidden surprises.",
    },
    {
      title: "Customer-Centric Approach",
      icon: icon4,
      desc: "Your needs drive our design, service, and overall experience.",
    },
  ];

  useEffect(() => {
    if (window.matchMedia("(min-width: 1024px)").matches) {
      // Pin the hero section while animations occur
      gsap.to(".main-about", {
        scrollTrigger: {
          trigger: ".main-about",
          start: "top top",
          end: "+=800", // Extended duration for smoother transition
          scrub: true,
          pin: true,
          anticipatePin: 1,
          pinSpacing: false,
        },
      });

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".parent",
          start: "top top",
          end: "bottom bottom",
          scrub: 2,
        },
      });

      tl.to(
        ".showreel h2",
        {
          scale: "0",
        },
        "a"
      ).to(
        ".showreel video",
        {
          scale: "1",
        },
        "a"
      );
    }
 
    if (window.matchMedia("(min-width: 1224px)").matches) {
      gsap.to(".portfolio-parent .scrolling-container", {
       
        scrollTrigger: {
          trigger: ".portfolio-parent",
          start: "top top",
          end: "+=800", // Extended duration for smoother transition
          scrub: true,
          pin: true,
          anticipatePin: 1,
          pinSpacing: false,
        },
      });


      // About section overlay animation
      gsap.to(".portfolio-parent", {
        opacity: 1,
        scrollTrigger: {
          trigger: ".portfolio-parent",
          start: "center center",
          end: "bottom bottom",
          scrub: true,
        },
      });
    }
  
    const cards = document.querySelector(".horizontal-cards");

    gsap.to(".horizontal-cards", {
      x: () => -(cards.scrollWidth - window.innerWidth),
      ease: "none",
      scrollTrigger: {
        trigger: ".about-horizontal",
        start: "top top",
        end: () => `+=${cards.scrollWidth}`,
        scrub: true,
        pin: true,
        anticipatePin: 1,
      },
    });

    if (window.matchMedia("(min-width: 1024px)").matches) {
      gsap.to(".about-section-image", {
        scale: 1.1,
        scrollTrigger: {
          trigger: ".about-section",
          start: "top bottom",
          end: "bottom top",
          scrub: 1,
        },
      });
    }

    // Setup for the Grand Vision auto-scrolling image strip
    if (window.matchMedia("(min-width: 100px)").matches) {
      const scrollContent = document.querySelector(".scrolling-content");

      // Calculate total width
      const items = gsap.utils.toArray(".scrolling-item");
      const itemWidth = items[0].offsetWidth;
      const gap = 20; // Gap between items
      const totalWidth = (itemWidth + gap) * items.length;

      // Duplicate content for seamless looping
      scrollContent.innerHTML += scrollContent.innerHTML;

      // GSAP animation for continuous scrolling
      gsap.to(scrollContent, {
        x: -totalWidth,
        duration: 40, // Adjust duration for speed
        ease: "none",
        repeat: -1, // Infinite loop
        modifiers: {
          x: gsap.utils.unitize((x) => parseFloat(x) % totalWidth),
        },
      });
    }

    gsap.registerPlugin(ScrollTrigger);

    gsap.from(headingRef.current, {
      opacity: 0,
      y: 50,
      duration: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: headingRef.current,
        start: "top 80%",
        toggleActions: "play none none none",
      },
    });
    // Infinite image scroll
    const scrollTimeline = gsap.timeline({ repeat: -1 });
    scrollTimeline.to(imageScrollRef.current, {
      x: "-50%",
      ease: "linear",
      duration: 20,
    });
  }, []);

  return (
    <div className="home-page bg-[#521a27]">
      <div className="main-home-section relative">
        <div
          id="top"
          className="hero w-full md:h-[130vh] min-h-screen flex flex-col items-center justify-start relative"
        >
          <h1 className="archivo 2xl:text-[85px] xl:text-[80px] lg:text-[80px] md:text-[70px] text-[40px] font-bold leading-[1em] text-white md:ml-[30px] ml-0 2xl:mt-[250px] xl:mt-[270px] lg:mt-[265px] mt-[230px]">
            Embrace Your Journey,

            <br />  Define Your Legacy. 

          </h1>
        </div>
        <div className="main-about relative bg-[#521a27] text-white z-[9999] md:px-20 px-8 md:pb-10 pb-5 ">
          <div className="about-home flex flex-col md:flex-row justify-between item-center w-full">
            <div className="about-home-content relative text-left">
              <h2 className="2xl:text-[70px] xl:text-[65px] lg:text-[63px] md:text-[45px] text-[33px] font-bold leading-[110%] lg:mb-[0px] mb-[10px] capitalize">
                About <br className="hidden lg:block" />
                Town Bell
              </h2>
            </div>
            <div className="max-w-3xl  text-[16px] md:border-l border-0  border-[#e9a455] md:pl-[40px] pl-0">
              <p className="text-[16px]">
                Town Bell is one of the most trusted and reputed real estate
                developers in the Tricity region, with a proven track record of
                delivering quality homes. Combining smart architecture, durable
                construction, and thoughtfully planned amenities, our projects
                are designed to offer lasting comfort and value. Backed by years
                of experience and a strong commitment to excellence, we focus on
                creating vibrant communities where families can truly thrive.
              </p>
              <p className="mt-4 text-[16px]">
                At Town Bell, we don’t just build homes—we build trust,
                relationships, and spaces that enrich everyday living.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Showreel Section */}
      <div className="parent w-full h-[fit-content] lg:h-[250vh] bg-[#521a27] relative">
        <div className="showreel w-full md:h-screen h-[60vh] lg:sticky top-0 flex flex-col items-center justify-center">
          <div className="top-blur absolute w-full h-[134px] pointer-events-none top-[-133px] left-p"></div>
          <h2 className="archivo xl:text-[140px] lg:text-[140px] md:text-[90px]  text-[40px]  font-bold leading-[1em] text-transparent mb-[15px] lg:mb-[0] md:mb-[10px] lg:absolute top-0 pt-[40px]">
            AMAYRA TRILLIUM
          </h2>
          <video
            autoPlay
            loop
            controls
            className="w-[95%] h-[60vh] md:h-full"
            src={video}
            loading="lazy"
            playsInline
            muted
            poster={townBuilding}
          ></video>
        </div>
      </div>

      {/* Portfolio Section */}
      <div
        id="projects"
        className="portfolio-parent w-full lg:h-[100vh] relative bg-white z-9"
        data-theme="light"
        style={{ background: "white" }}
      >
        <div className="portfolio w-full flex flex-col items-center sticky top-[0px] left-0 overflow-hidden">
          <div className="about-portfolio flex flex-col md:flex-row justify-between item-center w-full lg:pt-10 pt-5 lg:px-10 px-5 pb-5">
            <div className="about-portfolio-content relative text-left">
              <h2 className="h2 2xl:text-[55px] xl:text-[48px] lg:text-[46px] md:text-[40px] text-[30px]  font-bold leading-[120%] lg:mb-[0px] mb-[10px] capitalize">
                Amayra Trillium
                <br /> Redefining Urban Living
              </h2>
            </div>
            <div className="max-w-2xl text-[16px] md:pl-[40px] pl-[0px] items-center flex">
              <p className="text-gray font-normal  text-[16px]">
                Amayra Trillium brings you the perfect blend of luxury, comfort,
                and convenience—strategically located along the Kharar–Kurali
                Highway in the fast-developing Greater Mohali region. With easy
                access to major landmarks like Max Hospital, RayatBahra
                University, and Chandigarh International Airport, it offers
                unmatched connectivity while maintaining a peaceful residential
                atmosphere.
              </p>
            </div>
          </div>

          <section className="bg-white w-full overflow-hidden">
            {/* Auto Scrolling Image Strip */}
            <div className="relative w-full overflow-hidden py-4">
              <div className="scrolling-container overflow-hidden">
                <div className="scrolling-content flex">
                  {images.map((src, idx) => (
                    <div
                      key={idx}
                      className="scrolling-item mx-4 flex-shrink-0"
                    >
                      <img
                        src={src}
                        alt={`Gallery ${idx}`}
                         loading="lazy"
                        decoding="async"
                        className="lg:w-[400px] md:w-[370px] w-[300px] h-[300px] md:h-[400px] object-cover rounded-[2px]"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* about */}
      <section className="club w-full relative z-10 mt-[40px] ">
        {/* Top Section with Content and Background */}
        <div
          className="bg-cover bg-center text-white md:py-10 py-5  md:px-20 px-8"
          style={{
            backgroundImage: `url(${gardenView})`,
          }}
        >
          <div className="about-section rounded-xl w-full flex flex-col md:flex-row justify-between">
            <div className="about-content relative text-left">
              <h2 className="capitalize 2xl:text-[55px] xl:text-[48px] lg:text-[46px] md:text-[40px] text-[30px] font-bold leading-[110%]">
                Trillium <br className="hidden lg:block" />
                Clubhouse
              </h2>
            </div>
            <div className="max-w-2xl  md:pl-[40px] pl-[0px] items-center flex">
              <p className="text-white font-normal  text-[16px]">
                Experience leisure and luxury at the Trillium Clubhouse—where
                every amenity is designed for relaxation, recreation, and
                community connection.
              </p>
            </div>
          </div>
        </div>

        <div className="about-image-container lg:h-[100vh] h-[50vh] overflow-hidden">
          <img
            src={townBuilding}
            alt="Town Bell Garden"
            className="about-section-image w-full h-full object-cover transform scale-[1.2] origin-center"
            loading="lazy"
            decoding="async"
          />
        </div>
      </section>

      {/* Grand Vision Section */}
      <div className="about-horizontal">
        <div className="bg-white">
          <div className="flex flex-col md:flex-row justify-between item-center w-full py-[40px] md:px-[40px] px-[20px]">
            <div className="about-horizontal-content relative text-left">
              <h2 className="h2 2xl:text-[55px] xl:text-[48px] lg:text-[46px] md:text-[40px] text-[30px] font-bold leading-[110%] lg:mb-[0px] mb-[10px] capitalize pb-[5px]">
                Where Community and
                 Comfort Come Together
              </h2>
            </div>
            <div className="max-w-2xl text-[16px] md:pl-[40px] pl-[0px] items-center flex">
              <p className="text-gray font-normal  text-[16px]">
                Designed to foster a sense of belonging, Amayra Trillium is more
                than just a residential space—it’s a vibrant community. With a
                host of amenities like a clubhouse, yoga lawn, kids play area,
                and 24/7 security, it creates an environment where residents of
                all ages can thrive. Whether you're unwinding after work or
                connecting with neighbors, every corner is built to enhance your
                everyday life.
              </p>
            </div>
          </div>
        </div>
        <section className="bg-white w-full overflow-hidden pb-[40px]">
          {/* Horizontal Scrolling Image Strip */}
          <div className="horizontal-cards w-[95%] md:w-full flex items-center justify-center lg:justify-[unset] flex-col lg:flex-row gap-[15px] lg:gap-[50px] lg:translate-x-[60vw]">
            {portfolioItems.map((item, index) => (
              <a href="/" key={index}>
                <div className="card lg:w-[650px] md:w-[450px] w-[95%] md:h-[370px] h-[260px] rounded-[2px] relative overflow-hidden">
                  <img
                    className="w-full h-full object-cover object-center"
                    src={item.image}
                    alt={item.title}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </a>
            ))}
          </div>
        </section>
      </div>

      {/* build trust */}
      <section className="bannerb py-[60px] px-4">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-12">
          {/* Text Left */}
          <span className="space-y-4 mt-3">
            <h3
              ref={headingRef}
              className="flex capitalize md:text-[48px] text-[30px] text-white font-bold leading-[110%]"
            >
              Built on Trust. Backed <br /> by Experience.
            </h3>
            <p className="text-white text-[16px]">
              Whether you're a first-time homebuyer or an investor, <br />{" "}
              choosing Town Bell means choosing:
            </p>
          </span>

          {/* 4 Feature Boxes */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {boxes.map((item, idx) => (
              <div
                key={idx}
                className="flex justify-center gap-2 border border-white-600 py-6 p-2 text-white transition duration-300"
              >
                <div className="svg-div">
                  <img src={item.icon} alt={item.title} loading="lazy" decoding="async" />
                </div>
                <div className="flex flex-col p-1">
                  <h4 className="text-white-300 text-[16px]">{item.title}</h4>
                  {/* DASH LINE */}
                  <div className="w-10 h-[2px] bg-white my-3"></div>
                  <p className="text-[16px] text-white-300">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Exterior Image Section */}
      <section className="bg-white text-black py-[40px] md:px-[40px] px-[20px]">
        <div className="w-full flex flex-col md:flex-row gap-10">
          {/* Text */}
          <div className="space-y-2 lg:w-[60%] w-full">
            <h2 className="h2 2xl:text-[55px] xl:text-[48px] lg:text-[46px] md:text-[40px] text-[30px] font-bold leading-[110%] capitalize">
              Exterior  <br className="hidden lg:block" /> Amayra Trillium
            </h2>
            <p className="text-gray-700  text-[16px]">
              At Amayra Trillium, the exteriors blend modern design with natural
              beauty. From the grand entrance to landscaped open spaces, every
              detail is crafted to create a welcoming and elegant
              atmosphere—offering a perfect balance of style, space, and
              serenity.
            </p>
          </div>

          {/* Image slider - infinite scroll */}
          <div className="flex-2 overflow-hidden">
            <div className="flex w-[200%] gap-4" ref={imageScrollRef}>
              {[img1, img2, img3, img4, img5].map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt={`exterior-${idx}`}
                  className="w-1/3 object-cover shadow-lg 2xl:h-[75%] xl:h-[60%] lg:h-[55%] md:h-[50%] h-[45%]"
                  loading="lazy"
                  decoding="async"
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
